import "core-js/modules/es6.array.sort.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import flatten from 'lodash/flatten';
import invert from 'lodash/invert';
import isEmpty from 'lodash/isEmpty';
import keys from 'lodash/keys';
import transform from 'lodash/transform';
var PRODUCTS_PER_PAGE = 40;
var SORT_BY = {
  popular: 'popular',
  publishdate: 'publishdate',
  price: 'price'
};
var ORDER_BY = {
  default: 'default',
  asc: 'asc',
  desc: 'desc'
};
var ENCODED_CATEGORY_FILTERS = {
  'sold_by.seller_name': 'se',
  'filters.filter_eco_responsability.facet_label': 'ecr',
  'filters.filter_bed_size.facet_label': 'bes',
  'filters.filter_bed_head_size.facet_label': 'beh',
  'filters.filter_nb_seat.facet_label': 'nbs',
  'filters.filter_brand.facet_label': 'ba',
  'segmentations.category_name': 'ct',
  'filters.filter_capacity.facet_label': 'ca',
  'filters.filter_plus_product.facet_label': 'pp',
  'filters.filter_form.facet_label': 'fo',
  'filters.filter_ideal_for.facet_label': 'if',
  'filters.filter_christmas_theme.facet_label': 'cht',
  'filters.filter_bin_bag_capacity.facet_label': 'bib',
  'filters.filter_bin_model.facet_label': 'bim',
  'filters.filter_bin_opening_mechanism.facet_label': 'bio',
  'filters.filter_pushchair_model.facet_label': 'pum',
  'filters.filter_pushchair_accessories.facet_label': 'pua',
  'filters.filter_kid_theme.facet_label': 'kit',
  'segmentations.colors.label': 'c',
  'segmentations.styles.label': 'st',
  'segmentations.fabrics.label': 'f',
  price: 'p',
  'filters.filter_blanket_size.facet_label': 'bls',
  'filters.filter_sheet_size.facet_label': 'shs',
  'filters.filter_availability.facet_label': 'av',
  'segmentations.dimensions.depth': 'dd',
  'segmentations.dimensions.height': 'dh',
  'segmentations.dimensions.width': 'dw',
  more_info: 'mi',
  width: 'dw',
  height: 'dh',
  depth: 'dd',
  'filters.filter_armchair_model.facet_label': 'armo',
  'filters.filter_armrest.facet_label': 'arm',
  'filters.filter_bathroom_furniture_model.facet_label': 'baf',
  'filters.filter_bathroom_towel_model.facet_label': 'bat',
  'filters.filter_bed_model.facet_label': 'bem',
  'filters.filter_bulb_base_type.facet_label': 'bbt',
  'filters.filter_carpet_model.facet_label': 'cam',
  'filters.filter_characteristic.facet_label': 'cha',
  'filters.filter_cup_model.facet_label': 'cm',
  'filters.filter_curtain_tie_type.facet_label': 'cut',
  'filters.filter_duvet_size.facet_label': 'dus',
  'filters.filter_floor_lamp_model.facet_label': 'flm',
  'filters.filter_function.facet_label': 'fun',
  'filters.filter_furniture_model.facet_label': 'fum',
  'filters.filter_furniture_type.facet_label': 'fut',
  'filters.filter_gramma.facet_label': 'gra',
  'filters.filter_kitchen_furniture_model.facet_label': 'kif',
  'filters.filter_lamp_model.facet_label': 'lm',
  'filters.filter_lounge_chair_model.facet_label': 'loc',
  'filters.filter_chair_model.facet_label': 'chm',
  'filters.filter_mattress_comfort.facet_label': 'mac',
  'filters.filter_mattress_specificity.facet_label': 'mas',
  'filters.filter_mirror_model.facet_label': 'mm',
  'filters.filter_model.facet_label': 'm',
  'filters.filter_modular_type.facet_label': 'mot',
  'filters.filter_nb_door.facet_label': 'nbdo',
  'filters.filter_nb_drawer.facet_label': 'nbdr',
  'filters.filter_office_model.facet_label': 'ofm',
  'filters.filter_padding.facet_label': 'pad',
  'filters.filter_parasol_mast.facet_label': 'pam',
  'filters.filter_pattern.facet_label': 'pat',
  'filters.filter_pillow_bolster_size.facet_label': 'pib',
  'filters.filter_pose.facet_label': 'pos',
  'filters.filter_protective_cover.facet_label': 'prc',
  'filters.filter_quality_bed.facet_label': 'qub',
  'filters.filter_scent.facet_label': 'sc',
  'filters.filter_season.facet_label': 'sea',
  'filters.filter_sofa_corner.facet_label': 'soc',
  'filters.filter_sofa_type.facet_label': 'sot',
  'filters.filter_specific_treatment.facet_label': 'spt',
  'filters.filter_springbox_model.facet_label': 'spm',
  'filters.filter_support_bed_comfort.facet_label': 'sub',
  'filters.filter_table_model.facet_label': 'tam',
  'filters.filter_technology_mattress.facet_label': 'tem',
  'filters.filter_theme.facet_label': 't',
  'filters.filter_type_bulbs.facet_label': 'tb',
  'filters.filter_vase_model.facet_label': 'vm',
  'filters.filter_washable_care.facet_label': 'wc',
  'filters.filter_wick_thickness.facet_label': 'wit'
};
var DECODED_CATEGORY_FILTERS = invert(ENCODED_CATEGORY_FILTERS);
var extractFacetLabelFromCategoryFilters = (filters, filter, facet) => {
  var isNumericFacets = filter === 'price' || filter === 'width' || filter === 'height' || filter === 'depth';
  var isBooleanFacets = filter === 'more_info' || filter === 'is_new' || filter === 'is_on_sales' || filter === 'is_made_in_france';
  if (isNumericFacets || isBooleanFacets) return facet;
  var extracted = filters.find(e => e.name === filter).facets.find(e => e.key === facet);
  return extracted ? extracted.label : null;
};
var extractSelectedFilters = (filterBy, filters) => {
  if (!filters || !filterBy) return [];
  var result = [];
  Object.keys(filterBy).forEach(filter => {
    var hasDeepFilter = ['depth', 'width', 'height'].includes(filter);
    if (hasDeepFilter) {
      result.push({
        filter,
        facet: filterBy[filter][0],
        label: "".concat(filterBy[filter][0], " cm")
      });
    } else {
      result.push(filterBy[filter].map(facet => ({
        filter,
        facet,
        label: extractFacetLabelFromCategoryFilters(filters, filter, facet)
      })));
    }
  });
  return flatten(result);
};
var supportedFilterBy = (query, decoder) => {
  var supported = keys(decoder);
  return transform(query, (currentQuery, value, key) => {
    var isSupported = supported.includes(key) && value !== '';
    return Object.assign(currentQuery, isSupported && {
      [key]: value
    });
  }, {});
};
var extractFilterByFromQuery = decoder => query => transform(supportedFilterBy(query, decoder), (result, value, key) => {
  var currentResult = result;
  var hasSpace = /,(?=(\s|%20))/;
  if (hasSpace.test(value)) {
    currentResult[decoder[key]] = [value];
  } else {
    currentResult[decoder[key]] = !isEmpty(value) ? value.split(',') : [];
  }
}, {});
var extractQueryFromFilterBy = encoder => query => transform(query, (result, value, key) => {
  var currentResult = result;
  currentResult[encoder[key]] = value.length ? value.join(',') : null;
}, {});
var extractCategoryQueryFromFilterBy = extractQueryFromFilterBy(ENCODED_CATEGORY_FILTERS);
var extractCategoryFilterByFromQuery = extractFilterByFromQuery(DECODED_CATEGORY_FILTERS);
var extractCategorySortByFromQuery = query => SORT_BY[query.sort] || SORT_BY.popular;
var extractCategoryOrderByFromQuery = query => ORDER_BY[query.order] || null;
var extractPageFromQuery = query => parseInt(query.page, 10) || 1;
var extractCategoryPreviousPageFromQuery = extractPageFromQuery;
var extractCategoryNextPageFromQuery = extractPageFromQuery;
var buildCategoryProductsQuery = query => {
  var filterBy = extractCategoryFilterByFromQuery(query);
  var sortBy = extractCategorySortByFromQuery(query) || SORT_BY.popular;
  var orderBy = extractCategoryOrderByFromQuery(query) || ORDER_BY.default;
  var page = extractPageFromQuery(query) || 1;
  var algoliaFilters = JSON.stringify(query);
  return {
    offset: (extractPageFromQuery(query) - 1) * PRODUCTS_PER_PAGE,
    limit: PRODUCTS_PER_PAGE,
    sortBy: sortBy.toUpperCase(),
    orderBy: orderBy.toUpperCase(),
    filterBy: keys(filterBy).map(e => ({
      filter: e,
      facets: filterBy[e]
    })),
    algoliaFilters,
    page
  };
};
export { extractCategoryFilterByFromQuery, extractCategoryQueryFromFilterBy, extractCategorySortByFromQuery, extractCategoryOrderByFromQuery, extractCategoryPreviousPageFromQuery, extractCategoryNextPageFromQuery, buildCategoryProductsQuery, extractSelectedFilters };